import {Component, Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: "reverse"
})
class ReversePipe implements PipeTransform {

  transform(value: any): any {
    if (typeof value === "string") {
      return value.split("").reverse().join("");
    } else if (Array.isArray(value)) {
      return value.reverse();
    }
    return value;
  }
}

@Component({
  selector: "core-pipe",
  template: `
  <usecase-container title="Pipe" src="core/pipe">
    <usecase-content>
      <p>Plain: {{ text }}</p>
      <p>uppercase(builtin): {{ text | uppercase }}</p>
      <p>reverse(custom): {{ text | reverse }}</p>
    </usecase-content>
  </usecase-container>
  `,
  pipes: [ReversePipe]
})
export class PipeComponent {
  text: string = "Angular 2";
}



/** WEBPACK FOOTER **
 ** ./script/core/pipe/component.ts
 **/